var _defs, _g, _circle, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermostatBGmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 45,
    x2: 555,
    y1: 45,
    x1: 45,
    id: "prefix__b",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4985fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f82c3d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.155,
    floodColor: "#000",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.485,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#f7f8f8",
    cx: 300,
    cy: 300,
    r: 295
  }), /*#__PURE__*/React.createElement("circle", {
    r: 272.351,
    cx: 300,
    cy: 300,
    fill: "#fff",
    paintOrder: "stroke fill markers",
    filter: "url(#prefix__a)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 250
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.894 496.854A250 250 0 0150 300 250 250 0 01300 50a250 250 0 01250 250 250 250 0 01-95.894 196.853",
    stroke: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.106 496.853A250 250 0 01300 550a250 250 0 01-154.106-53.146",
    stroke: "#52575b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostatBGmin);
export default __webpack_public_path__ + "static/media/ThermostatBG.min.a46e101a80863ade3158ff5c963670ba.svg";
export { ForwardRef as ReactComponent };